function isLoggedIn() {
  const kUser = localStorage.getItem("k-user") && localStorage.getItem("loggedIn") 
  const retorno = kUser !== null && kUser !== "" ? true : false;

  return retorno;
}

const userLoggedIn = {
  userLoggedIn: isLoggedIn(),
};

export default userLoggedIn;
